import type { ReactNode } from "react";
import { RowPick } from "@nova/desk-ui/parts";
import { Info } from "@nova/desk-ui/kit";
import { SHOW_TEMPLATE_COPY, SHOW_TEMPLATES, type ShowTemplateId } from "./showTemplates.js";

export function ShowTemplatePicker({
  value,
  onPick,
  disabled = false,
}: {
  readonly value: ShowTemplateId | null;
  readonly onPick: (template: ShowTemplateId) => void;
  readonly disabled?: boolean;
}): ReactNode {
  return (
    <fieldset className="set">
      {/* The October hand-off's (i) in the legend, rather than a line of help
          under it. A legend is not a label, so the (i) takes no control's name. */}
      <legend className="label">
        Quick start
        <Info label="About Quick start">
          Prefills registration drafts. You can change every choice afterwards. Skip this to start
          from a blank setup.
        </Info>
      </legend>
      <div className="rows">
        {SHOW_TEMPLATES.map((template) => {
          const copy = SHOW_TEMPLATE_COPY[template];
          return (
            <RowPick
              key={template}
              type="radio"
              name="show-template"
              title={copy.title}
              desc={copy.body}
              on={value === template}
              onPick={() => {
                if (!disabled) onPick(template);
              }}
            />
          );
        })}
      </div>
    </fieldset>
  );
}
